import { request, Rows } from './request';
import AppError from './models/common/res/AppError';
import { AfterNotice } from './models/after-notice/res';

/**
 * 시술 유의 사항 목록 조회
 */
export const fetchAfterNoticeList = async (params: {
  partnerId: number | string;
  ids: number[];
  languageCode?: string;
}) => {
  try {
    const { data } = await request<Rows<AfterNotice>>({
      method: 'get',
      url: `/mini-web/after-notices`,
      queryParams: {
        ...params,
      },
    });
    return data;
  } catch (e) {
    throw new AppError(e);
  }
};
